<template>
  <v-app id="app">
    <Header></Header>
      <router-view />
    <Footer></Footer>
  </v-app>
</template>

<style>
/* google fontsをインポート */
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP&display=swap');

#app {
  font-family: 'Noto Sans JP', sans-serif;
  overflow: hidden;
}
</style>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  name: 'App',

  components: {
    Header,
    Footer
  },

  data: () => ({
    //
  })
}
</script>
